import React from 'react'
import {useAttendee} from 'Event/auth'
import {eventRoutes} from 'Event/Routes'
import {Redirect} from 'react-router-dom'
import TechCheck from 'Event/Step3/TechCheck'
import {useEvent, useHasTechCheck} from 'Event/EventProvider'
import {useTrackEventPage} from 'analytics'
import {useTemplate} from 'Event/TemplateProvider'
import {hasMatch} from 'Event/attendee-rules/matcher'
import {useSubmissions} from 'Event/SubmissionsProvider'
import Scripts, {CHECK_IN_TECH_CHECK} from 'Event/Scripts'

export default function Step3() {
  const attendee = useAttendee()
  const hasTechCheck = useHasTechCheck()
  const matchesRulesToSkip = useMatchesRulesToSkipTechCheck()

  useTrackEventPage({
    page: 'Visited Step 3',
  })
  if (matchesRulesToSkip) {
    return <Redirect to={eventRoutes.root} />
  }

  if (attendee.has_completed_tech_check || !hasTechCheck) {
    return <Redirect to={eventRoutes.root} />
  }

  return (
    <>
      <Scripts page={CHECK_IN_TECH_CHECK} />
      <TechCheck />
    </>
  )
}

export function useMatchesRulesToSkipTechCheck() {
  const template = useTemplate()
  const attendee = useAttendee()
  const {answers} = useSubmissions()
  const {event} = useEvent()
  const {forms} = event

  return hasMatch(
    {groups: attendee.groups, tags: attendee.tags, answers, forms},
    template.techCheck.skipRules,
  )
}
